import React, { useState } from 'react';

import linkIcon from 'images/referral/link_icon.svg';

import styles from './styles.module.css';

const LinkCopy = ({
  referralUrl,
  customClass,
  ahoyEventName,
}: {
  referralUrl: string;
  customClass?: string;
  ahoyEventName?: string;
}) => {
  const [copyText, setCopyText] = useState('Copy Link');

  const ClickHandler = () => {
    navigator.clipboard.writeText(referralUrl);
    setCopyText('Link Copied!');
    setTimeout(() => setCopyText('Copy Link'), 2000);
    if (ahoyEventName) {
      // @ts-expect-error TODO: import ahoy instead of using global instance?
      ahoy.track(ahoyEventName);
    }
  };

  return (
    <div className={customClass}>
      <div className={styles.linkContainer}>
        <img src={linkIcon} width={15} height={15} />
        <div className={styles.link}>{referralUrl}</div>
      </div>
      <button className={styles.copyLink} onClick={ClickHandler} type="button">
        {copyText}
      </button>
    </div>
  );
};

export default LinkCopy;
